import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// Components
import EditDetails from './EditDetails';
import MyButton from '../../utils/MyButton';
import ProfileSkeleton from '../../utils/ProfileSkeleton';

// Redux
import { connect } from 'react-redux';
import { logoutUser, uploadImage } from '../../redux/actions/userActions';

// MUI stuff
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';

// Icon
import LocationOn from '@mui/icons-material/LocationOn';
import LinkIcon from '@mui/icons-material/Link';
import CalendarToday from '@mui/icons-material/CalendarToday';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardReturn from '@mui/icons-material/KeyboardReturn';

import theme from '../../utils/theme';

const styles = {
    ...theme
};

class Profile extends Component {

    handleImageChange = (event) => {
        const image = event.target.files[0];
        const formData = new FormData();
        formData.append('image', image, image.name);
        this.props.uploadImage(formData);
    }

    handleEditPicture = _ => document.getElementById('imageInput').click();

    handleLogout = _ => this.props.logoutUser();

    render() {
        const {
            classes,
            user: {
                credentials: { handle, createdAt, imageUrl, bio, website, location },
                loading,
                authenticated
            }
        } = this.props;

        let profileMarkerup = !loading
            ? (authenticated
                ? (
                    <Paper className={classes.paper}>
                        <div className={classes.profile}>
                            <div className="image-wrapper">
                                <img src={imageUrl} alt="profile" className="profile-image" />
                                <input type="file" id="imageInput" onChange={this.handleImageChange} hidden />
                                <MyButton tip="Edit Profile Picture" onClick={this.handleEditPicture} btnClassName="button">
                                    <EditIcon color="primary" />
                                </MyButton>
                            </div>
                            <hr />
                            <div className="profile-details">
                                <MuiLink component={Link} to={`/users/${handle}`} color="primary" variant="h5">
                                    @{handle}
                                </MuiLink>
                                <hr />
                                {bio && <Typography variant="body2">{bio}</Typography>}
                                <hr />
                                {location && (
                                    <Fragment>
                                        <LocationOn color="primary" /><span>{location}</span>
                                        <hr />
                                    </Fragment>
                                )}
                                {website && (
                                    <Fragment>
                                        <LinkIcon color="primary" />
                                        <a href={website} target="_blank" rel="noopener noreferrer">
                                            {' '}{website}
                                        </a>
                                        <hr />
                                    </Fragment>
                                )}
                                <CalendarToday color="primary" />
                                <span>Joined {dayjs(createdAt).format('MMM YYYY')}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <MyButton tip="Logout" onClick={this.handleLogout} >
                                    <KeyboardReturn color="primary" />
                                </MyButton>
                                <EditDetails />
                            </div>
                        </div>
                    </Paper>
                )
                : (
                    <Paper className={classes.paper}>
                        <Typography variant="body2" align="center">
                            No profile found, please login again
                        </Typography>
                        <div className={classes.buttons}>
                            <Button variant="contained" color="primary" component={Link} to="/login">Login</Button>
                            <Button variant="contained" color="primary" component={Link} to="/signup">Signup</Button>
                        </div>
                    </Paper>
                )
            )
            : <ProfileSkeleton />;

        return (profileMarkerup);
    }
}

Profile.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    uploadImage: PropTypes.func.isRequired,
    logoutUser: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({ user: state.user });

// const mapActionsToPros = () => ({ uploadImage, logoutUser });

export default connect(mapStateToProps, { uploadImage, logoutUser })(withStyles(styles)(Profile))
